export default __webpack_public_path__ + "static/media/CapitalReputacional.903cc242.svg";